import React from 'react';

import RabbyLogo from '../../assets/logo/rabby.png';
import TronLinkLogo from '../../assets/logo/tronlink.png';
import TrustWalletLogo from '../../assets/logo/trustwallet.png';
import { ImgProps } from '../display/Img';
import { RoundImg } from '../display/RoundImg';
import { Svg, SvgIconProps } from './common';

export const RabbyIcon = (props: Omit<ImgProps, 'src'>) => (
  <RoundImg {...props} src={RabbyLogo} />
);

export const TronLinkIcon = (props: Omit<ImgProps, 'src'>) => (
  <RoundImg {...props} src={TronLinkLogo} />
);

export const TrustWalletIcon = (props: Omit<ImgProps, 'src'>) => (
  <RoundImg {...props} src={TrustWalletLogo} />
);

export const LedgerIcon: React.FC<SvgIconProps> = (props) => (
  <Svg viewBox="0 0 147 128" {...props}>
    <path
      d="M0 91.6548V128H55.293V119.94H8.05631V91.6548H0ZM138.944 91.6548V119.94H91.707V127.998H147V91.6548H138.944ZM55.3733 36.3452V91.6529H91.707V84.3842H63.4296V36.3452H55.3733ZM0 0V36.3452H8.05631V8.05844H55.293V0H0ZM91.707 0V8.05844H138.944V36.3452H147V0H91.707Z"
      fill="black"
    />
  </Svg>
);

export const MetamaskIcon: React.FC<SvgIconProps> = (props) => (
  <Svg viewBox="0 0 212 189" {...props}>
    // @ts-ignore
    <g fill="none" fillRule="evenodd">
      <polygon
        fill="#CDBDB2"
        points="60.75 173.25 88.313 180.563 88.313 171 90.563 168.75 106.313 168.75 106.313 180 106.313 187.875 89.438 187.875 68.625 178.875"
      ></polygon>
      <polygon
        fill="#CDBDB2"
        points="105.75 173.25 132.75 180.563 132.75 171 135 168.75 150.75 168.75 150.75 180 150.75 187.875 133.875 187.875 113.063 178.875"
        transform="matrix(-1 0 0 1 256.5 0)"
      ></polygon>
      <polygon
        fill="#393939"
        points="90.563 152.438 88.313 171 91.125 168.75 120.375 168.75 123.75 171 121.5 152.438 117 149.625 94.5 150.188"
      ></polygon>
      <polygon
        fill="#F89C35"
        points="75.375 27 88.875 58.5 95.063 150.188 117 150.188 123.75 58.5 136.125 27"
      ></polygon>
      <polygon
        fill="#F89D35"
        points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"
      ></polygon>
      <polygon
        fill="#D87C30"
        points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"
      ></polygon>
      <polygon
        fill="#EA8D3A"
        points="46.125 101.813 65.25 119.813 65.25 137.813"
      ></polygon>
      <polygon
        fill="#F89D35"
        points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"
      ></polygon>
      <polygon
        fill="#EB8F35"
        points="65.25 138.375 60.75 173.25 90.563 152.438"
      ></polygon>
      <polygon
        fill="#EA8E3A"
        points="92.25 102.375 95.063 150.188 86.625 125.719"
      ></polygon>
      <polygon
        fill="#D87C30"
        points="39.375 138.938 65.25 138.375 60.75 173.25"
      ></polygon>
      <polygon
        fill="#EB8F35"
        points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"
      ></polygon>
      <polygon
        fill="#E8821E"
        points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"
      ></polygon>
      <polygon
        fill="#DFCEC3"
        points="60.75 173.25 90.563 152.438 88.313 170.438 88.313 180.563 68.063 176.625"
      ></polygon>
      <polygon
        fill="#DFCEC3"
        points="121.5 173.25 150.75 152.438 148.5 170.438 148.5 180.563 128.25 176.625"
        transform="matrix(-1 0 0 1 272.25 0)"
      ></polygon>
      <polygon
        fill="#393939"
        points="70.313 112.5 64.125 125.438 86.063 119.813"
        transform="matrix(-1 0 0 1 150.188 0)"
      ></polygon>
      <polygon
        fill="#E88F35"
        points="12.375 .563 88.875 58.5 75.938 27"
      ></polygon>
      <path
        fill="#8E5A30"
        d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"
      ></path>
      <g transform="matrix(-1 0 0 1 211.5 0)">
        <polygon
          fill="#F89D35"
          points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"
        ></polygon>
        <polygon
          fill="#D87C30"
          points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"
        ></polygon>
        <polygon
          fill="#EA8D3A"
          points="46.125 101.813 65.25 119.813 65.25 137.813"
        ></polygon>
        <polygon
          fill="#F89D35"
          points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"
        ></polygon>
        <polygon
          fill="#EB8F35"
          points="65.25 138.375 60.75 173.25 90 153"
        ></polygon>
        <polygon
          fill="#EA8E3A"
          points="92.25 102.375 95.063 150.188 86.625 125.719"
        ></polygon>
        <polygon
          fill="#D87C30"
          points="39.375 138.938 65.25 138.375 60.75 173.25"
        ></polygon>
        <polygon
          fill="#EB8F35"
          points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"
        ></polygon>
        <polygon
          fill="#E8821E"
          points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"
        ></polygon>
        <polygon
          fill="#393939"
          points="70.313 112.5 64.125 125.438 86.063 119.813"
          transform="matrix(-1 0 0 1 150.188 0)"
        ></polygon>
        <polygon
          fill="#E88F35"
          points="12.375 .563 88.875 58.5 75.938 27"
        ></polygon>
        <path
          fill="#8E5A30"
          d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"
        ></path>
      </g>
    </g>
  </Svg>
);

export const PhantomIcon: React.FC<SvgIconProps> = (props) => (
  <Svg viewBox="0 0 1200 1200" {...props}>
    <g clipPath="url(#clip0_2596_138580)">
      <rect y="-0.000976562" width="1200" height="1200" fill="#AB9FF2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M522.218 764.813C475.101 837.011 396.147 928.377 291.089 928.377C241.425 928.377 193.671 907.932 193.671 819.121C193.671 592.942 502.479 242.812 789.003 242.812C952.003 242.812 1016.95 355.901 1016.95 484.325C1016.95 649.167 909.979 837.65 803.647 837.65C769.901 837.65 753.346 819.121 753.346 789.731C753.346 782.064 754.62 773.758 757.167 764.813C720.874 826.788 650.835 884.292 585.253 884.292C537.499 884.292 513.304 854.262 513.304 812.093C513.304 796.759 516.487 780.786 522.218 764.813ZM769.035 479.871C769.035 517.293 746.956 536.003 722.258 536.003C697.185 536.003 675.481 517.293 675.481 479.871C675.481 442.449 697.185 423.738 722.258 423.738C746.956 423.738 769.035 442.449 769.035 479.871ZM909.367 479.872C909.367 517.294 887.288 536.005 862.59 536.005C837.517 536.005 815.813 517.294 815.813 479.872C815.813 442.45 837.517 423.74 862.59 423.74C887.288 423.74 909.367 442.45 909.367 479.872Z"
        fill="#FFFDF8"
      />
    </g>
    <defs>
      <clipPath id="clip0_2596_138580">
        <rect
          y="-0.000976562"
          width="1200"
          height="1200"
          rx="600"
          fill="white"
        />
      </clipPath>
    </defs>
  </Svg>
);

export const SolflareIcon: React.FC<SvgIconProps> = (props) => (
  <Svg viewBox="0 0 248 248" {...props}>
    <g clipPath="url(#clip0_3159_613)">
      <path
        d="M125.43 210.536C127.404 210.536 129.004 212.119 129.004 214.072C129.004 216.024 127.404 217.607 125.43 217.607C123.456 217.607 121.855 216.024 121.855 214.072C121.855 212.119 123.456 210.536 125.43 210.536ZM121.547 41.6533C123.293 41.7976 124.704 43.1212 124.94 44.8373L129.192 75.7285C130.62 85.9345 142.929 90.3565 150.527 83.4211L193.125 44.6496C194.152 43.7143 195.753 43.7791 196.699 44.7943C197.568 45.7258 197.594 47.1518 196.76 48.1136L159.614 90.9618C152.776 98.836 157.822 111.132 168.246 112.01L201.021 115.169C202.653 115.326 203.848 116.761 203.688 118.374C203.557 119.704 202.532 120.778 201.196 120.987L166.757 126.364C156.758 127.727 152.229 139.568 158.733 147.261L170.841 161.534C171.816 162.684 171.663 164.398 170.499 165.361C169.513 166.178 168.086 166.21 167.063 165.437L152.138 154.166C144.084 148.109 132.474 153.257 131.623 163.281L128.334 202.376C128.198 203.991 126.763 205.191 125.129 205.057C123.742 204.943 122.621 203.892 122.433 202.53L117.217 164.766C115.819 154.56 103.51 150.138 95.8819 157.073L50.5665 198.335C49.6285 199.189 48.1673 199.13 47.3028 198.204C46.5097 197.353 46.4856 196.051 47.2467 195.173L86.7949 149.532C93.6332 141.658 88.6185 129.362 78.1935 128.485L45.4113 125.324C43.779 125.167 42.5848 123.732 42.7441 122.119C42.8754 120.789 43.8999 119.715 45.2359 119.506L79.6525 114.13C89.6518 112.767 94.2106 100.926 87.7067 93.2332L79.465 83.5171C78.2555 82.0912 78.4449 79.9666 79.8881 78.7715C81.1114 77.7586 82.8822 77.7197 84.1499 78.6779L94.2711 86.3283C102.325 92.3852 113.935 87.2371 114.786 77.2129L117.509 45.0274C117.681 42.994 119.488 41.4834 121.547 41.6533ZM34.3621 118.507C36.3363 118.507 37.9366 120.089 37.9366 122.042C37.9366 123.994 36.3363 125.577 34.3621 125.577C32.388 125.577 30.7876 123.994 30.7876 122.042C30.7876 120.089 32.388 118.507 34.3621 118.507ZM213.638 114.917C215.612 114.917 217.212 116.5 217.212 118.452C217.212 120.405 215.612 121.988 213.638 121.988C211.664 121.988 210.063 120.405 210.063 118.452C210.063 116.5 211.664 114.917 213.638 114.917ZM121.03 30.3931C123.005 30.3931 124.605 31.9759 124.605 33.9285C124.605 35.881 123.005 37.4639 121.03 37.4639C119.056 37.4639 117.456 35.881 117.456 33.9285C117.456 31.9759 119.056 30.3931 121.03 30.3931Z"
        fill="url(#paint0_linear_3159_613)"
      />
      <path
        d="M123.175 153.643C141.824 153.643 156.941 138.691 156.941 120.247C156.941 101.803 141.824 86.8508 123.175 86.8508C104.527 86.8508 89.41 101.803 89.41 120.247C89.41 138.691 104.527 153.643 123.175 153.643Z"
        fill="url(#paint1_radial_3159_613)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3159_613"
        x1="55.1462"
        y1="60.1723"
        x2="162.052"
        y2="156.952"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC10B" />
        <stop offset="1" stopColor="#FB3F2E" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3159_613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(115.464 107.918) rotate(67.5196) scale(49.0906 49.5676)"
      >
        <stop stopColor="#FFC10B" />
        <stop offset="1" stopColor="#FB3F2E" />
      </radialGradient>
      <clipPath id="clip0_3159_613">
        <rect
          width="188"
          height="188"
          fill="white"
          transform="translate(30 30)"
        />
      </clipPath>
    </defs>
  </Svg>
);
